module.exports = __webpack_public_path__ + "img/diproses2.720c7043.png";